import PropTypes from "prop-types";
import { Content } from "./Content";

export const VersionedSpaceWrapper = ({ children, isLockedSpace }) => {
  if (isLockedSpace) {
    return children;
  }
  return <Content>{children}</Content>;
};

VersionedSpaceWrapper.propTypes = {
  isLockedSpace: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};
